import {
  Component,
  OnInit,
} from '@angular/core';

import { DataService } from 'src/app/services/data.service';
import { MenuService } from 'src/app/services/menu.service';

import {
  AlertController,
  NavController,
} from '@ionic/angular';
// import { Storage } from '@ionic/storage';
import { Storage } from '@ionic/storage-angular';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
})
export class SideMenuComponent implements OnInit {
  hover_menu = false;
  constructor(public db:DataService, public menu: MenuService,private navCtrl: NavController,
    private alertCtrl: AlertController,  private storage: Storage, ) { }

  ngOnInit() {}

  async logout() {
    let alert = await this.alertCtrl.create({
      header: 'Confirm',
      message: 'Do you really want to logout?',
      buttons: [
        {
          text: 'No',
          role: 'cancel'
        },
        {
          text: 'Yes',
          handler: () => {
            localStorage.clear();
            this.storage.clear();
            this.storage.remove('survey_info');
            location.href = '/';
          }
        }
      ]
    })
    await alert.present();
  }

  openPage(page) {
    // console.log(page)
    if(page.label == 'Inventory')
      this.db.stack_tranfer = false
    
    this.navCtrl.navigateRoot([page.url], {});
  }
}
